module.exports = __webpack_public_path__ + "img/play-icon.bab7ff8e.svg";